import React, { useState } from 'react';
import PageLayout from './PageLayout';
import { useTranslation } from 'react-i18next';

// 画像ファイルをインポート
import SleepPASImage from '../images/pas.png';
import RDclubImage from '../images/RDclub.png';
import ProgImage from '../images/prog.png';
import DrowsinessGlassesImage from '../images/drowsiness_glasses.jpg';
import StudentPRImage from '../images/student_pr.jpg';
import TaiwanPBLImage from '../images/taiwan_pbl.jpg';
import ExpoImage1 from '../images/expo1.jpg';

const productImages = [
  DrowsinessGlassesImage,
  ProgImage,
  SleepPASImage
];

const activityImages = [
  ExpoImage1,
  TaiwanPBLImage,
  RDclubImage,
  StudentPRImage
];

const PortfolioPage = () => {
  const { t } = useTranslation();
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemType, setItemType] = useState(null);

  const translatedProducts = t('product.productsData', { returnObjects: true });
  const productsData = Array.isArray(translatedProducts)
    ? translatedProducts.map((item, index) => ({
        ...item,
        image: productImages[index] || DrowsinessGlassesImage,
        details: item.features ? {
          period: item.period,
          technology: item.technology,
          features: item.features,
          team: item.team,
          learning: item.learning
        } : null
      }))
    : [];

  const translatedActivities = t('product.activityData', { returnObjects: true });
  const activityData = Array.isArray(translatedActivities)
    ? translatedActivities.map((item, index) => ({
        ...item,
        image: activityImages[index] || ExpoImage1,
        details: item.overview ? {
          overview: item.overview,
          team: item.team,
          role: item.role,
          learning: item.learning
        } : null
      }))
    : [];

  // カードクリック時の処理
  const handleCardClick = (item, type) => {
    setSelectedItem(item);
    setItemType(type);
  };

  // 詳細ボックスを閉じる処理
  const closeDetailsBox = () => {
    setSelectedItem(null);
    setItemType(null);
  };

  return(
    <PageLayout>
      <div className='container'>
      {/* 詳細表示ボックス */}
      {selectedItem && (
        <>
          <div className="details-backdrop" onClick={closeDetailsBox}></div>
          <div className="details-box-from-top">
            <div className="details-box-content">
              {/* 画像 */}
              {selectedItem.image && (
                <img 
                  src={selectedItem.image} 
                  alt={selectedItem.title} 
                  className="details-image" 
                />
              )}
              
              {/* 基本情報 */}
              <div className="text-content">
                <time>{selectedItem.date}</time>
                <h3>{selectedItem.title}</h3>
                <p className="description-main">{selectedItem.description}</p>
                
                {/* 詳細情報 */}
                {selectedItem.details && (
                  <div className="more-details">
                    <hr style={{margin: '20px 0', border: '1px solid #e0e0e0'}} />
                    
                    {/* Productsの詳細項目 */}
                    {itemType === 'product' && (
                      <>
                        {/* 開発期間 */}
                        <div className="detail-section">
                          <h4>{t('product.period')}</h4>
                          <p>{selectedItem.details.period}</p>
                        </div>
                        
                        {/* 使用技術 */}
                        <div className="detail-section">
                          <h4>{t('product.technology')}</h4>
                          <p>{selectedItem.details.technology}</p>
                        </div>
                        
                        {/* 特徴・機能 */}
                        <div className="detail-section">
                          <h4>{t('product.features')}</h4>
                          <ul>
                            {selectedItem.details.features && selectedItem.details.features.map((feature, index) => (
                              <li key={index}>{feature}</li>
                            ))}
                          </ul>
                        </div>
                        
                        {/* 開発チーム */}
                        <div className="detail-section">
                          <h4>{t('product.team')}</h4>
                          <p>{selectedItem.details.team}</p>
                        </div>
                        
                        {/* 得た学び */}
                        <div className="detail-section">
                          <h4>{t('product.learning')}</h4>
                          <p>{selectedItem.details.learning}</p>
                        </div>
                      </>
                    )}
                    
                    {/* Activitiesの詳細項目 */}
                    {itemType === 'activity' && (
                      <>
                        {/* 概要 */}
                        <div className="detail-section">
                          <h4>{t('product.overview')}</h4>
                          <p>{selectedItem.details.overview}</p>
                        </div>
                        
                        {/* チーム */}
                        <div className="detail-section">
                          <h4>{t('product.activityTeam')}</h4>
                          <p>{selectedItem.details.team}</p>
                        </div>
                        
                        {/* 役割 */}
                        <div className="detail-section">
                          <h4>{t('product.role')}</h4>
                          <p>{selectedItem.details.role}</p>
                        </div>
                        
                        {/* 得た学び */}
                        <div className="detail-section">
                          <h4>{t('product.learning')}</h4>
                          <p>{selectedItem.details.learning}</p>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
            <button onClick={closeDetailsBox} className="close-button">×</button>
          </div>
        </>
      )}

      {/* --- アクティビティ セクション --- */}
      <section id="activities" className="my-5"> 
        <h2 className="title page-first-heading">{t('product.activities')}</h2>
        <div className="activity-container">
          {activityData.map((activity, index) => (
            <div 
              className="activity-item clickable-card" 
              key={`activity-${index}`}
              onClick={() => handleCardClick(activity, 'activity')}
              style={{cursor: 'pointer'}}
            >
              <img src={activity.image} alt={activity.title} />
              <div className="activity-item-content">
                <time className="activity-date">{activity.date}</time>
                <h3 className='activity-title'>{activity.title}</h3>
                <p className='activity-description'>{activity.description}</p>
                <div className="click-hint">{t('product.clickHint')}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* --- プロダクト セクション --- */}
      <section id="products" className="my-5">
        <h2 className="title">{t('product.products')}</h2>
        <div className="product-container">
          {productsData.map((product, index) => (
            <div 
              key={`product-${index}`} 
              className="product-item clickable-card"
              onClick={() => handleCardClick(product, 'product')}
              style={{cursor: 'pointer'}}
            >
              <img src={product.image} alt={product.title} className="product-image" />
              <div className="product-item-content">
                <time className="product-date">{product.date}</time>
                <h3 className='product-title'>{product.title}</h3>
                <p className='product-description'>{product.description}</p>
                <div className="click-hint">{t('product.clickHint')}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
      </div>
    </PageLayout>
  );
};

export default PortfolioPage;